import { getCellDefaults } from '~shared/types'
import { parseSnapshot } from '~shared/utils'

/**
 * Cell specific wrapper for parseSnapshot
 */
export function parseCellSnapshot(snapshot) {
  const defaults = getCellDefaults()
  const dateKeys = []
  return parseSnapshot(snapshot, { defaults, dateKeys })
}
